import type { EventTracking } from '../types';
import { mergeDicts } from '../utils/merge';
import account from './account.tracking';
import dismissableBanner from './dismissableBanner.tracking';
import carousel from './carousel.tracking';
import favorites from './favorites.tracking';
import filters from './filters.tracking';
import location from './location.tracking';
import links from './links.tracking';
import modals from './modals.tracking';
import nav from './nav.tracking';
import onboarding from './onboarding.tracking';
import search from './search.tracking';
import singleCard from './singleCard.tracking';
import tray from './tray.tracking';

// This tracking merger makes a very strong assumption that
// you do NOT use another action type within your tracking
// duckling.
//
// In other words, only track events that correspond to the
// mother duck, don't track other events; you are free however
// to use fields from other stores

// Combine all the ducklings into a single object.
const tracking: EventTracking = mergeDicts(
  account,
  dismissableBanner,
  carousel,
  favorites,
  filters,
  links,
  modals,
  location,
  nav,
  onboarding,
  search,
  singleCard,
  tray,
);

export default tracking;
